export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Usuario', inactivar: 'Inactivar Usuario'},
				modals: []
			},

			tableGBSearch: ['list_users/name'],
			
			tableGBItems: [				
				{
					thead: { th: 'Usuario', sort: null, sortTable: 'list_users/name'},
					tbody: { td: ['list_users/name'],}
				},
				{
					thead: { th: 'Email', },
					tbody: { td: ['list_users/email'],}
				},
			]			
		}
	},
}